// extracted by mini-css-extract-plugin
export default {"stockGrid":"products_stockGrid__SDsbn"};